import { BaseFilterComponent } from './types';
import { Filter } from '../../types';
import { NumericFilterOption } from '../options/types';
import { TextField } from '@lifeomic/chroma-react/components/TextField';
import { useIntl } from 'react-intl';
import * as React from 'react';

interface NumericEntryProps extends NumericFilterOption, BaseFilterComponent {}

export const NumericEntry: React.FC<NumericEntryProps> = ({
  injectedProps: { numericEntryOption, searchKey },
  onFilterAdd,
  origin,
}) => {
  const { formatMessage } = useIntl();

  const [textValue, setTextValue] = React.useState('');

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextValue(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!textValue || textValue?.trim?.()?.length === 0) {
      return;
    }

    if (e.key !== 'Enter') {
      return;
    }

    if (onFilterAdd) {
      const option: Filter = {
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        id: numericEntryOption.id,
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        origin,
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        searchKey,
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        searchValue: `${textValue}${numericEntryOption.valuePostfix}`,
      };

      onFilterAdd(option);
    }

    setTextValue('');
  };

  return (
    <TextField
      type="number"
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      placeholder={formatMessage(numericEntryOption.placeholderIntlLabel)}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      aria-label={formatMessage(numericEntryOption.placeholderIntlLabel)}
      value={textValue}
      onChange={handleTextFieldChange}
      onKeyPress={handleKeyPress}
      fullWidth
    />
  );
};
